import React from 'react';
import StaticPageLayout from './StaticPageLayout';

const TermsOfServicePage = () => {
  return (
    <StaticPageLayout title="Terms and Conditions">
      <p className="static-page__muted">Last updated: Feb 10, 2026</p>

      <p>
        By using Zoomed In, creating an account, or buying coins, you agree to
        these Terms and Conditions. If you do not agree, please do not use the
        app.
      </p>

      <h3>Eligibility and accounts</h3>
      <ul>
        <li>
          You are responsible for activity under your account and for keeping
          your login credentials secure.
        </li>
        <li>Use accurate information when creating your account.</li>
        <li>
          We may suspend or limit accounts involved in abuse, fraud, or misuse.
        </li>
      </ul>

      <h3>Acceptable use</h3>
      <ul>
        <li>Do not spam, hack, scrape, reverse engineer, or exploit the app.</li>
        <li>Do not interfere with ads or attempt invalid ad interactions.</li>
        <li>Do not abuse payment, referral, or coin systems.</li>
      </ul>

      <h3>Coins, purchases, and payments</h3>
      <ul>
        <li>
          Coins and in-app benefits are virtual items for use inside the app.
          They are not real money and have no cash value.
        </li>
        <li>
          Payments are processed by third-party providers (for example, Stripe).
        </li>
        <li>
          Prices may change. Taxes or fees may apply depending on your region.
        </li>
        <li>
          Refund requests are reviewed case-by-case and may be denied except
          where required by law.
        </li>
      </ul>

      <h3>Service availability</h3>
      <p>
        We may update, pause, or discontinue parts of the app at any time. We
        do our best to keep the service reliable, but uptime is not guaranteed.
      </p>

      <h3>Content and intellectual property</h3>
      <p>
        The app, branding, software, and original content belong to Zoomed In
        or its licensors. Third-party content (such as image providers or map
        data) remains subject to its own licenses and terms.
      </p>

      <h3>Disclaimer and limitation of liability</h3>
      <p>
        The service is provided &quot;as is&quot; and &quot;as available&quot; without
        warranties. To the maximum extent permitted by law, we are not liable
        for indirect, incidental, special, consequential, or punitive damages.
      </p>

      <h3>Changes to these terms</h3>
      <p>
        We may update these Terms. Continued use of the app after updates means
        you accept the revised Terms.
      </p>

      <h3>Contact</h3>
      <p>
        Questions? Email{' '}
        <a href="mailto:imran@playgroundlogic.com">imran@playgroundlogic.com</a>.
      </p>
    </StaticPageLayout>
  );
};

export default TermsOfServicePage;

